<div>
  <button mat-button mat-dialog-close style="float: right">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content style="clear: both">
  <div>
    <h3 style="font-weight: bold">Send Update Request Email: Lab# {{incidentRecord.LabNumber}}</h3>
    <hr>

    <!--<div style="font-size:10pt; text-align:center; color:blue; margin:10px;">
      <span style="border-radius: 10px; border: 2px solid blue;padding: 10px;"> The button with a <mat-icon [inline]="true">contact_mail</mat-icon> icon will allow you to import emails saved in the system.</span>
    </div>-->

    <table style="width: 100%">
      <tr>
        <td style="font-weight: bold; width: 80px;">
          TO:
          <button mat-icon-button [matMenuTriggerFor]="importGrpMenuTO" style="margin:5px" matTooltip="Import Email Group"><mat-icon>contact_mail</mat-icon></button>
          <mat-menu #importGrpMenuTO="matMenu">
            <button mat-menu-item *ngFor="let g of EmailGroups" (click)="importEmailFromGroup(g, 'to')">
              {{g.group}}
            </button>
          </mat-menu>
        </td>
        <td>
          <mat-form-field appearance="standard" style="width: 100%">
            <mat-chip-list #toList>
              <mat-chip *ngFor="let e of emailSendForm.to" [selectable]="selectable" [removable]="removable" (removed)="remove(e,'to')">
                {{e}}
                <button matChipRemove *ngIf="removable">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip>
              <input placeholder="example@backtracereports.com"
                     [matChipInputFor]="toList"
                     [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                     [matChipInputAddOnBlur]="addOnBlur"
                     (matChipInputTokenEnd)="add($event,'to')">
            </mat-chip-list>
          </mat-form-field>
        </td>
      </tr>
    </table>

    <mat-expansion-panel class="mat-elevation-z0" >
      <mat-expansion-panel-header>
        <mat-panel-title>
          CLICK TO EXPAND FOR BCC, CC, AND REPLY TO
        </mat-panel-title>
      </mat-expansion-panel-header>
      <table style="width: 100%">
        <tr>
          <td style="font-weight: bold; width: 90px;">
            CC:
            <button mat-icon-button [matMenuTriggerFor]="importGrpMenuCC" style="margin:5px" matTooltip="Import Email Group"><mat-icon>contact_mail</mat-icon></button>
            <mat-menu #importGrpMenuCC="matMenu">
              <button mat-menu-item *ngFor="let g of EmailGroups" (click)="importEmailFromGroup(g, 'cc')">
                {{g.group}}
              </button>
            </mat-menu>
          </td>
          <td>
            <mat-form-field appearance="standard" style="width: 100%">
              <mat-chip-list #ccList>
                <mat-chip *ngFor="let e of emailSendForm.cc" [selectable]="selectable" [removable]="removable" (removed)="remove(e,'cc')">
                  {{e}}
                  <button matChipRemove *ngIf="removable">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip>
                <input placeholder="example@backtracereports.com"
                       [matChipInputFor]="ccList"
                       [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                       [matChipInputAddOnBlur]="addOnBlur"
                       (matChipInputTokenEnd)="add($event,'cc')">
              </mat-chip-list>
            </mat-form-field>
          </td>
        </tr>
        <tr>
          <td style="font-weight: bold; width: 90px;">
            BCC:
            <button mat-icon-button [matMenuTriggerFor]="importGrpMenuBCC" style="margin:5px" matTooltip="Import Email Group"><mat-icon>contact_mail</mat-icon></button>
            <mat-menu #importGrpMenuBCC="matMenu">
              <button mat-menu-item *ngFor="let g of EmailGroups" (click)="importEmailFromGroup(g, 'bcc')">
                {{g.group}}
              </button>
            </mat-menu>
          </td>
          <td>
            <mat-form-field appearance="standard" style="width: 100%">
              <mat-chip-list #bccList>
                <mat-chip *ngFor="let e of emailSendForm.bcc" [selectable]="selectable" [removable]="removable" (removed)="remove(e,'bcc')">
                  {{e}}
                  <button matChipRemove *ngIf="removable">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip>
                <input placeholder="example@backtracereports.com"
                       [matChipInputFor]="bccList"
                       [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                       [matChipInputAddOnBlur]="addOnBlur"
                       (matChipInputTokenEnd)="add($event,'bcc')">
              </mat-chip-list>
            </mat-form-field>
          </td>
        </tr>

        <tr>
          <td style="font-weight: bold; width: 90px;">Reply To:</td>
          <td>
            <mat-form-field appearance="standard" style="width: 100%">
              <mat-chip-list #ReplyList>
                <mat-chip *ngFor="let e of emailSendForm.replyto" [selectable]="selectable" [removable]="removable" (removed)="remove(e,'replyto')">
                  {{e}}
                  <button matChipRemove *ngIf="removable">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip>
                <input placeholder="example@backtracereports.com"
                       [matChipInputFor]="ReplyList"
                       [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                       [matChipInputAddOnBlur]="addOnBlur"
                       (matChipInputTokenEnd)="add($event,'replyto')">
              </mat-chip-list>
            </mat-form-field>
          </td>
        </tr>

      </table>
    </mat-expansion-panel>


    <table style="width: 100%">
      <tr>
        <td style="font-weight: bold; width: 50px;">Message:</td>
        <td><textarea rows="10" style="width: 100%" [(ngModel)]="emailSendForm.message" name="emailMSG"></textarea></td>
      </tr>
      <tr>
        <td colspan="2"><button mat-button (click)="sendEmail()"><mat-icon>email</mat-icon> Send</button></td>
      </tr>
    </table>

  </div>
</div>

